const translations = {
    addBoundary: 'Add Boundary',
    addFarm: 'Add Farm',
    addField: 'Add Field'
};

export default translations;
